<script lang="ts">
	import { Button } from 'flowbite-svelte';
	import { ChevronUp } from 'svelte-heros-v2';
	import { fade } from 'svelte/transition';

	let scrollHeight = 0;
	let clientHeight = 0;
	$: visible = scrollHeight > clientHeight / 4;

	const scrollToTop = () => {
		document.body.scrollIntoView({ behavior: 'smooth' });
	};
</script>

<svelte:window bind:innerHeight={clientHeight} bind:scrollY={scrollHeight} />

{#if visible}
	<div transition:fade>
		<Button
			on:click={scrollToTop}
			class="!p-0 w-20 h-20 bg-white hover:bg-white focus:ring-0 rounded-full flex justify-center items-center shadow-mg"
		>
			<ChevronUp size="45px" class="text-blue-900 outline-none pointer-events-none" />
		</Button>
	</div>
{/if}
